"use strict";
/**
 * Text difficulty calculation constants and utilities
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_SIZE_DIFFICULTY_MODIFIER = exports.LEVEL_BASE_DIFFICULTY = void 0;
exports.calculateTextDifficulty = calculateTextDifficulty;
exports.getDifficultyLabel = getDifficultyLabel;
exports.getRecommendedTextSizes = getRecommendedTextSizes;
const textValidation_1 = require("../rules/textValidation");
/**
 * Base difficulty mapping for proficiency levels
 */
exports.LEVEL_BASE_DIFFICULTY = {
    BEGINNER: 2,
    ELEMENTARY: 3,
    INTERMEDIATE: 5,
    UPPER_INTERMEDIATE: 6,
    ADVANCED: 8,
    PROFICIENT: 9,
};
/**
 * Text size difficulty modifiers
 */
exports.TEXT_SIZE_DIFFICULTY_MODIFIER = {
    SHORT: -0.5, // Slightly easier
    MEDIUM: 0, // No change
    LONG: +0.5, // Slightly harder
};
/**
 * Calculate text difficulty based on proficiency level and size
 */
function calculateTextDifficulty(level, textSize = "MEDIUM") {
    const baseDifficulty = exports.LEVEL_BASE_DIFFICULTY[level];
    const sizeModifier = exports.TEXT_SIZE_DIFFICULTY_MODIFIER[textSize];
    // Apply modifier and clamp to valid range
    const adjustedDifficulty = Math.round(baseDifficulty + sizeModifier);
    return Math.max(1, Math.min(10, adjustedDifficulty));
}
/**
 * Get difficulty label for display
 */
function getDifficultyLabel(difficulty) {
    if (difficulty <= 2)
        return "Very Easy";
    if (difficulty <= 4)
        return "Easy";
    if (difficulty <= 6)
        return "Medium";
    if (difficulty <= 8)
        return "Hard";
    return "Very Hard";
}
/**
 * Get recommended text sizes for a proficiency level
 */
function getRecommendedTextSizes(level) {
    return (0, textValidation_1.getRecommendedTextSizesForLevel)(level);
}
//# sourceMappingURL=difficulties.js.map